import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export function StatCard({ label, children, minHeight = 78 }) {
  return (
    <div
      style={{
        border: '1px solid #E5E7EB',
        borderRadius: 8,
        padding: 16,
        background: '#FFFFFF',
        minHeight,
      }}
    >
      {label ? <Text style={{ color: '#9CA3AF', fontSize: 12 }}>{label}</Text> : null}
      <div style={{ marginTop: label ? 6 : 0 }}>{children}</div>
    </div>
  );
}

export function BigStatValue({ children }) {
  return <div style={{ fontSize: 24, fontWeight: 600, color: '#111827', lineHeight: 1.1 }}>{children}</div>;
}

